export function filterObjectsByAllProperties(objects, searchTerm) {
    return objects.filter(obj => {
      return Object.values(obj).some(value => 
        String(value).toLowerCase().includes(searchTerm.toLowerCase())
      );
    });
}